import { SystemAdditionalParameterResponse, SystemItemResponse } from "src/core/models/systems";
import { SystemResponse } from "src/core/models/systems/SystemResponse";

export interface Project {
  projectName?: string | null;
  partnerId: number;
  projectSystems: Array<ProjectSystem>;
}

export interface ProjectSystem {
  index: number;
  name?: string | null;
  requiredQuantity: number;
  requiredApplianceThickness: number;
  additionalParameters?: Array<ProjectSystemAdditionalParameter> | null;
  system: SystemResponse;
  allSystems: Array<SystemResponse>;
  itemDifference: Array<SystemItemResponse>;
}

export interface ProjectSystemAdditionalParameter {
  id?: number;
  value?: number;
  systemAdditionalParameterId?: number;
  systemAdditionalParameter?: SystemAdditionalParameterResponse;
}

export interface systemAdditionalParameter {
  id?: number;
  minValue?: number;
  maxValue?: number;
  parameterType?: number;
  systemId?: number;
  unitOfMeasurement?: string;
}

export const SYSTEM_PARAMETER_TYPE = {
  WallThickness: 1,
  NumberOfPanels: 2,
  None: 3,
  BaseType: 4,
  InsulationMaterialType: 5,
  FacadeSystemType: 6,
  LeadThickness: 7,
  CoatingType: 8,
  AntiCorrosionCategory: 9,
  SteelProfile: 10,
  ApplianceThickness: 11,
};

export const SYSTEM_PARAMETER_TYPE_NAMES = [
  { id: 1, text: "Odaberite debljinu zida" },
  { id: 2, text: "Odaberite broj ploča" },
  { id: 4, text: "Odaberite vrstu podloge" },
  { id: 5, text: "Odaberite vrstu izolacijskog materijala" },
  { id: 6, text: "Odaberite vrstu / tip fasadnog sustava" },
  { id: 7, text: "Odaberite debljinu olova" },
  { id: 8, text: "Odaberite vrstu obloge" },
  { id: 9, text: "Odaberite kategoriju antikorozivne zaštite" },
  { id: 10, text: "Odaberite vrstu čeličnog profila" },
  { id: 11, text: "Odaberite debljinu nanošenja" },
];

export const APPLIANCE_THICKNESS_ITEMS = ["207346"];
